var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCluster56 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  x: 7,
  y: 7,
  fill: "#FF617E",
  rx: 21
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 49,
  height: 49,
  x: 3.5,
  y: 3.5,
  stroke: "#FF617E",
  strokeOpacity: 0.4,
  strokeWidth: 7,
  rx: 24.5
})));
export { SvgCluster56 as ReactComponent };
export default __webpack_public_path__ + "58e169886af39fcdd21ee34abcd882a1.svg";